import './ajax.js';
jQuery(function ($) {
  $(document).ready(function () {
       

  });
});